module.exports = __webpack_public_path__ + "static/media/icon_safari_240.a5bc1b09.png";